// extracted by mini-css-extract-plugin
export default {"mainContent":"styles_mainContent__nRE6M","formConteiner":"styles_formConteiner__Dn-0n","formWrapper":"styles_formWrapper__Iab7c","languageSwitcher":"styles_languageSwitcher__VISWD"};